import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import './assets/css/index.css';
import './components/common/SweetAlert.css';
import { App } from './App';
import { Provider } from 'react-redux';
import { render } from 'react-dom';

import { store } from './helper/redux_store';
import ChatProvider from './components/context/ChatProvider';
import { MainContextProvider } from './context/main/main-context-provider';
import { AssessmentContextProvider } from './context/assessment/assessment-context-provider';

import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./appInsights";


render(
    <AppInsightsContext.Provider value={reactPlugin}>
        <Provider store={store}>
            <MainContextProvider>
                <AssessmentContextProvider>
                    <ChatProvider>
                        <App />
                    </ChatProvider>
                </AssessmentContextProvider>
            </MainContextProvider>
        </Provider>
    </AppInsightsContext.Provider>,
    document.getElementById('root')
);